import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { parseKeyToDataTest } from '../../../utils';
import { SwitchRow } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
var noop = function noop() {};
export function ToggleControlUi(_ref) {
  var _ref2, _relatedUiProps$visib;
  var decoratorProps = _ref.decoratorProps,
    uiProps = _ref.uiProps,
    value = _ref.value,
    onChange = _ref.onChange,
    watchedValues = _ref.watchedValues,
    relateFn = _ref.relateFn,
    accessorKey = _ref.accessorKey;
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedDecoratorProps = _useMemo.decoratorProps,
    relatedUiProps = _useMemo.uiProps;
  var dataTestAttribute = parseKeyToDataTest('toggle', accessorKey);
  var visible = (_ref2 = (_relatedUiProps$visib = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib !== void 0 ? _relatedUiProps$visib : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref2 !== void 0 ? _ref2 : true;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsx(SwitchRow, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    checked: value || false,
    onChange: onChange !== null && onChange !== void 0 ? onChange : noop,
    dataTestId: dataTestAttribute
  }, decoratorProps), relatedDecoratorProps), uiProps), relatedUiProps));
}